module.exports = __webpack_public_path__ + "img/office-building.a888bf2e.png";